import React, { Fragment } from 'react';
import styled from '../../styled';
import { Chevron } from '../icons/outline';
const DefaultLink = styled.a `
  text-decoration: none;
  line-height: 1.43;
  color: #777777;

  &:hover {
    cursor: pointer;
    color: #3493fb;
  }
`;
const StyledLink = styled.span `
  text-decoration: none;
  line-height: 1.43;
  color: #777777;

  &:hover {
    cursor: pointer;
    color: #3493fb;
  }
`;
const Label = styled.span `
  color: ${props => (props.isActive ? '#000' : 'inherit')};
`;
const Wrapper = styled.h1 `
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 1.125rem;
  font-weight: 200;
  color: #777777;

  > * {
    vertical-align: middle;
  }

  > svg {
    fill: ${props => props.theme.colors.INK_400};
  }

  a {
    text-decoration: none;
  }
`;
const getLink = ({ id, label, url, renderLink }) => renderLink ? (renderLink(React.createElement(StyledLink, null, label))) : (React.createElement(DefaultLink, { href: url, key: id }, label));
const BreadcrumbV1 = ({ items }) => (React.createElement(Wrapper, null, items.map((item, index) => {
    const isActive = index === items.length - 1;
    const hasLink = item.url || item.renderLink;
    return (React.createElement(Fragment, { key: item.id },
        index > 0 && React.createElement(Chevron, { size: "MEDIUM", position: "RIGHT" }),
        hasLink ? (getLink(item)) : (React.createElement(Label, { isActive: isActive }, item.label))));
})));
export default BreadcrumbV1;
//# sourceMappingURL=index.js.map